<template>
    <div class="vrm-search-modal-no-results">
        <p v-if="searchError">
            {{
                $t('nav.enhanced_search.error', {
                    i18nFallback: 'Oops, something went wrong.',
                })
            }}
        </p>
        <p v-else>
            {{
                $t('nav.enhanced_search.no_installations_found', {
                    i18nFallback: 'No installations found with',
                })
            }}
            <span>{{ searchTermOnFail }}</span>
        </p>
        <ul>
            <li>
                {{
                    $t('nav.enhanced_search.no_installations_hint1', {
                        i18nFallback: 'Make sure that all the words are spelled correctly',
                    })
                }}
            </li>
            <li>
                {{
                    $t('nav.enhanced_search.no_installations_hint2', {
                        i18nFallback: 'Try a different query',
                    })
                }}
            </li>
        </ul>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    props: {
        searchTermOnFail: {
            type: String,
            default: '',
        },
        searchError: {
            type: Boolean,
            default: false,
        },
    },
})
@AngularLocaleBundle('nav')
@AngularDirective('vrm-enhanced-search-active-noresults')
export default class VrmEnhancedSearchActiveNoResults extends Vue {}
</script>
